import classNames from 'classnames';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import type { Skin } from '@sorare/core/src/__generated__/globalTypes';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { SkinIcon } from '@sorare/core/src/components/collections/SkinIcon';
import { selectOne, useFacet } from '@sorare/core/src/contexts/graphql-search';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { MENU } from '@sorare/core/src/lib/filters';
import { SKINS } from '@sorare/core/src/set/index.ts';

const SkinButton = styled(ButtonBase)`
  opacity: 0.3;
  &.active {
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  }
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.6;
  }
`;

type BackendProps = {
  visible: boolean;
  hideCount?: boolean;
};

const BackendFilter = ({ visible, hideCount }: BackendProps) => {
  const { items, refine } = useFacet('skin');

  const activeSkins = items.filter(i => i.isRefined).map(i => i.value);

  if (!visible) {
    return null;
  }

  return (
    <Horizontal center className="FilterWidget visible">
      {SKINS.map(s => {
        const lower = s.toLowerCase();
        return (
          <SkinButton
            key={s}
            className={classNames({
              active: activeSkins.includes(lower),
            })}
            onClick={() => refine(selectOne(lower))}
          >
            <SkinIcon skin={s as Skin} size={4} />
            {!hideCount && (
              <BrandM>
                <FormattedNumber
                  value={items.find(i => i.value === lower)?.count || 0}
                  notation="compact"
                />
              </BrandM>
            )}
          </SkinButton>
        );
      })}
    </Horizontal>
  );
};

export const backendWidget = ({
  hideCount,
}: { hideCount?: boolean } = {}): FilterWidget => ({
  key: MENU.skin.attribute,
  type: 'menu',
  attribute: MENU.skin.attribute,
  Component: props => <BackendFilter {...props} hideCount={hideCount} />,
});
